import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadState, removeState, saveState } from '../Common/localStorage';

const TOKEN = 'UserDetail';

export const connectUserDetail = (WrappedComponent) => {
  const mapStateToProps = (state) => {
    const {
      userDetail
    } = state;
    return { userDetail };
  };
  return connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
};

export const hasUserDetailManager = (WrappedComponent) => {
  return class DetailPropsProxy extends Component {
    render() {
      return (
        <ConnectedUserDetailManager>
        { (state, methods) => (
          <div className="h-100">
            <WrappedComponent {...state} {...methods} {...this.props} />
          </div>
          )
        }
        </ConnectedUserDetailManager>
      );
    }
  };
};

class UserDetailManager extends Component {
  constructor(props) {
    super(props);
    this.setDetail = this.setDetail.bind(this);
    this.state = {
      isExists: false
    };
    const token = loadState(TOKEN);
    if (token) {
      this.state.isExists = true;
    }
    this.getDetail = this.getDetail.bind(this);
    this.setDetail = this.setDetail.bind(this);

  }
  getDetail() {
    const token = loadState(TOKEN);
    if (!token) {
      // somehow token missing
      this.setDetail(null);
      return null;
    } else if (!this.state.isExists) {
      this.setState({
        isExists: true
      });
    }
    return JSON.parse(token);
  }
  setDetail(token) {
    if (token) {
      saveState(TOKEN, token);
      this.setState({
        isExists: true
      });
      this.props.setUserDetail({ userDetail: token });
    } else {
      removeState(TOKEN);
      this.setState({
        isExists: false
      });
      this.props.removeUserDetail();
    }
  }

  render() {
    const { state, setDetail, getDetail } = this;
    return (
      <div className="h-100">
        {this.props.children(state, {
          setDetail, getDetail
        })}
      </div>
    );
  }
}

const setPayload = payload => ({ type: 'USER_DETAIL', payload });

const mapDispatchToProps = dispatch => ({
  setUserDetail: payload => dispatch(setPayload(payload)),
  removeUserDetail: () => {
    removeState(TOKEN);
    dispatch(setPayload({ userDetail: {} }));
  },
});

const ConnectedUserDetailManager = connect(null, mapDispatchToProps)(UserDetailManager);
export default ConnectedUserDetailManager;



// WEBPACK FOOTER //
// ./src/Auth/UserDetailManager.js